<template>
  <div style="word-wrap:break-word;word-break:break-all; ">
    <!--<yw-head></yw-head>-->
    <div class="web-body">
      <div class="about" style="padding: 30px 20px">
        <div class=WordSection1 style='layout-grid:15.6pt'>

          <p class=MsoNormal align=center style='text-align:center;margin-bottom: 20px'><b><span lang=ZH-CN
                                                                                                 style='font-size:10.0pt;font-family:FangSong'>第三方服务共享清单</span></b>
          </p>

          <p class=MsoNormal><span lang=EN-US style='font-size:10.0pt;font-family:FangSong'>&nbsp;</span></p>

          <p class=MsoNormal><span lang=EN-US style='font-size:10.0pt;font-family:FangSong'>&nbsp;</span></p>

          <p class=MsoNormal><span lang=EN-US style='font-size:10.0pt;font-family:FangSong'>&nbsp;</span></p>

          <p class=MsoNormal style='text-indent:24.0pt'><span lang=ZH-CN
                                                              style='font-size:10.0pt;font-family:FangSong'>为保障SUNNYRIDE游戏的稳定运行并实现相关功能，我们可能向第三方共享您的个人信息。如我们与任何第三方共享您的个人信息，我们将督促该第三方按照我们在《隐私政策》中与您的约定收集和使用您的个人信息，并采取适当的安全技术和管理措施保障您的个人信息安全。</span>
          </p>

          <p class=MsoNormal><span lang=EN-US style='font-size:10.0pt;font-family:FangSong'>&nbsp;</span></p>

          <p class=MsoNormal style='text-indent:24.0pt'><span lang=ZH-CN
                                                              style='font-size:10.0pt;font-family:FangSong'>我们可能会通过接入由第三方提供的软件工具开发包（</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>SDK</span><span
              lang=ZH-CN
              style='font-size:10.0pt;font-family:FangSong'>）的形式与该第三方共享您的个人信息。我们会对第三方获取信息的软件工具开发包（</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>SDK</span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>）进行严格的安全监测，以保护您的个人信息安全。</span></p>

          <p class=MsoNormal><span lang=EN-US style='font-size:10.0pt;font-family:FangSong'>&nbsp;</span></p>

          <p class=MsoNormal style='text-indent:24.0pt'><span lang=ZH-CN
                                                              style='font-size:10.0pt;font-family:FangSong'>本清单中我们将披露与SUNNYRIDE游戏存在信息共享的主体名称、个人信息使用目的、个人信息处理方式、个人信息类型及第三方隐私政策或官网链接。您可在以下表格中查看对应游戏的第三方</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>SDK</span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>信息及共享情况。您还可以通过第三方隐私政策或者官方网站链接查看第三方收集使用个人信息的规则。第三方可能由于版本或功能升级等原因改变其个人信息收集处理规则，请以其公示的官方说明为准。</span>
          </p>

          <p class=MsoNormal><span lang=EN-US style='font-size:10.0pt;font-family:FangSong'>&nbsp;</span></p>

          <p class=MsoNormal><span lang=EN-US style='font-size:10.0pt;font-family:FangSong'>&nbsp;</span></p>

          <p class="MsoNormal sdk-title"><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>SDK</span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>名称</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>   </span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>：</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'> </span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>百度游戏</span></b><b><span lang=EN-US style='font-size:10.0pt;
font-family:FangSong'>SDK</span></b></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>所属机构及官网</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>北京百度移讯科技有限公司</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>http://app.baidu-mgame.com/yyjr/wysdk</span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>使用目的及场景</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>推送消息、投放广告</span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>信息种类</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>设备标识信息、读取手机状态、存储</span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>处理方式</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>去标识化、加密传输的安全处理方式</span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>隐私政策</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  http://privacy.baidu.com/mdetail?id=288</span>
          </p>

          <p class=MsoNormal><span lang=EN-US style='font-size:10.0pt;font-family:FangSong'>&nbsp;</span></p>

          <p class="MsoNormal sdk-title"><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>SDK</span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>名称</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>   </span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>：</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'> 360SDK </span></b></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>所属机构及官网</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>北京奇虎科技有限公司</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'> http://dev.360.cn/wiki/</span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>使用目的及场景</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>推送消息、投放广告</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>信息种类</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>设备标识信息、账号状态、地理位置、文件读取权限</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>处理方式</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>去标识化、加密传输的安全处理方式</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>隐私政策</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  http://i.360.cn/reg/privacy </span></p>

          <p class=MsoNormal><span lang=EN-US style='font-size:10.0pt;font-family:FangSong'>&nbsp;</span></p>

          <p class="MsoNormal sdk-title"><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>SDK</span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>名称</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>   </span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>：</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'> </span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>微博</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>SDK</span></b></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>所属机构及官网</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>北京微梦创科网络技术有限公司</span><span
              lang=EN-US
              style='font-size:10.0pt;font-family:FangSong'>https://open.weibo.com/wiki/SDK#Android_SDK</span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>使用目的及场景</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>登录、 分享</span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>信息种类</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>读取手机状态和身份、修改或删除存储卡中的内容</span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>处理方式</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>去标识化、加密传输的安全处理方式</span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>隐私政策</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  https://www.weibo.com/signup/v5/privacy</span>
          </p>

          <p class=MsoNormal><span lang=EN-US style='font-size:10.0pt;font-family:FangSong'>&nbsp;</span></p>

          <p class="MsoNormal sdk-title"><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>SDK</span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>名称</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>   </span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>：</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'> </span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>微信</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>SDK</span></b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>所属机构及官网</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>腾讯公司</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   https://open.weixin.qq.com/</span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>使用目的及场景</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>登录、分享</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'> </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>信息种类</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>设备标识信息、地理位置、读取手机状态、存储</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>处理方式</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>去标识化、加密传输的安全处理方式</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>隐私政策</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  https://www.tencent.com/zh-cn/privacy-policy.html    </span>
          </p>

          <p class=MsoNormal><span lang=EN-US style='font-size:10.0pt;font-family:FangSong'>&nbsp;</span></p>

          <p class="MsoNormal sdk-title"><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>SDK</span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>名称</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>   </span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>：</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'> </span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>魅族</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>SDK</span></b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>所属机构及官网</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>珠海市魅族通讯设备有限公司</span><span
              lang=EN-US
              style='font-size:10.0pt;font-family:FangSong'>  https://open.flyme.cn/open-web/views/push.html</span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>使用目的及场景</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>推送消息、投放广告</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>信息种类</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>设备标识信息、读取手机状态、存储</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>处理方式</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>去标识化、加密传输的安全处理方式</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>隐私政策</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  https://i.flyme.cn/privacy  </span></p>

          <p class=MsoNormal><span lang=EN-US style='font-size:10.0pt;font-family:FangSong'>&nbsp;</span></p>

          <p class="MsoNormal sdk-title"><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>SDK</span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>名称</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>   </span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>：</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'> </span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>华为</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>SDK</span></b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>所属机构及官网</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>华为软件技术有限公司</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'> https://developer.huawei.com/consumer/cn/service/hms/pushservice.html</span>
          </p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>使用目的及场景</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>推送消息、投放广告</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>信息种类</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>设备标识信息、</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>SD</span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>卡写入权限、地理位置、读取通话状态</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>处理方式</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>去标识化、加密传输的安全处理方式</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>隐私政策</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  https://consumer.huawei.com/cn/privacy/privacy-policy/  </span>
          </p>

          <p class="MsoNormal sdk-title"><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>SDK</span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>名称</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>   </span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>：</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'> OPPO SDK</span></b><span lang=EN-US style='font-size:10.0pt;
font-family:FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>所属机构及官网</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>广东欢太科技有限公司</span><span
              lang=EN-US
              style='font-size:10.0pt;font-family:FangSong'> https://open.oppomobile.com/wiki/doctid=10196</span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>使用目的及场景</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>推送消息、投放广告、获取登录账号进行游戏登录</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>信息种类</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>设备标识信息、</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>SD</span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>卡写入权限、地理位置、存储、应用账户列表</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>处理方式</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>去标识化、加密传输的安全处理方式</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>隐私政策</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  https://muc.heytap.com/document/heytap/privacyPolicy/privacyPolicy_zh-CN.html    </span>
          </p>

          <p class=MsoNormal><span lang=EN-US style='font-size:10.0pt;font-family:FangSong'>&nbsp;</span></p>

          <p class="MsoNormal sdk-title"><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>SDK</span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>名称</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>   </span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>：</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'> </span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>小米</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>SDK</span></b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>所属机构及官网</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>小米科技有限责任公司</span><span
              lang=EN-US
              style='font-size:10.0pt;font-family:FangSong'> https://dev.mi.com/console/appservice/push.html</span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>使用目的及场景</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>推送消息、投放广告</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>信息种类</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>设备标识信息、存储、</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>SD</span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>卡写入权限、读取手机状态</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>处理方式</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>去标识化、加密传输的安全处理方式</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>隐私政策</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US
              style='font-size:10.0pt;font-family:FangSong'>  https://privacy.mi.com/miaccount/zh_CN/   </span></p>

          <p class=MsoNormal><span lang=EN-US style='font-size:10.0pt;font-family:FangSong'>&nbsp;</span></p>

          <p class="MsoNormal sdk-title"><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>SDK</span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>名称</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>   </span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>：</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'> VIVO SDK</span></b><span lang=EN-US style='font-size:10.0pt;
font-family:FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>所属机构及官网</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>维沃移动通信有限公司</span><span
              lang=EN-US
              style='font-size:10.0pt;font-family:FangSong'> https://dev.vivo.com.cn/documentcenter/doc/233</span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>使用目的及场景</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>推送消息、投放广告</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>信息种类</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>设备标识信息、接受短信、存储、地理位置信息、</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>SD</span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>卡读取、写入权限</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'> </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>处理方式</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>去标识化、加密传输的安全处理方式</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>隐私政策</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  https://dev.vivo.com.cn/documentCenter/doc/366   </span>
          </p>

          <p class=MsoNormal><span lang=EN-US style='font-size:10.0pt;font-family:FangSong'>&nbsp;</span></p>

          <p class="MsoNormal sdk-title"><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>SDK</span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>名称</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>   </span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>：</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'> </span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>三星</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>SDK</span></b></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>所属机构及官网</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>三星电子株式会社</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>https://developer.samsung.com/</span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>使用目的及场景</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>推送消息、投放广告</span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>信息种类</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>设备标识信息</span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>处理方式</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>去标识化、加密传输的安全处理方式</span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>隐私政策</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  https://account.samsung.com/membership/terms/privacypolicy</span>
          </p>

          <p class=MsoNormal><span lang=EN-US style='font-size:10.0pt;font-family:FangSong'>&nbsp;</span></p>

          <p class="MsoNormal sdk-title"><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>SDK</span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>名称</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>   </span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>：</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'> </span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>微信</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>SDK</span></b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>所属机构及官网</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>腾讯公司</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   https://open.weixin.qq.com/</span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>使用目的及场景</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>登录、分享</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'> </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>信息种类</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>设备标识信息、地理位置、读取手机状态、存储</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>处理方式</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>去标识化、加密传输的安全处理方式</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>隐私政策</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  https://www.tencent.com/zh-cn/privacy-policy.html    </span>
          </p>

          <p class=MsoNormal><span lang=EN-US style='font-size:10.0pt;font-family:FangSong'>&nbsp;</span></p>

          <p class="MsoNormal sdk-title"><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>SDK</span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>名称</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>   </span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>：</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'> </span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>微信分享</span></b><b><span lang=EN-US style='font-size:10.0pt;
font-family:FangSong'>SDK  </span></b></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>所属机构及官网</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>腾讯公司</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   https://open.weixin.qq.com/</span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>使用目的及场景</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>登录、 分享</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>信息种类</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  Wifi</span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>状态、手机状态、网络状态</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>处理方式</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>去标识化、加密传输的安全处理方式</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>隐私政策</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  https://privacy.qq.com/  </span></p>

          <p class=MsoNormal><span lang=EN-US style='font-size:10.0pt;font-family:FangSong'>&nbsp;</span></p>

          <p class="MsoNormal sdk-title"><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>SDK</span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>名称</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>   </span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>：</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'> qq</span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>互联移动应用</span></b><b><span lang=EN-US style='font-size:10.0pt;
font-family:FangSong'>SDK  </span></b></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>所属机构及官网</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>腾讯公司</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   http://wiki.connect.qq.com/sdk%e4%b8%8b%e8%bd%bd</span>
          </p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>使用目的及场景</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>登录、 分享、 支付</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>信息种类</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>访问大致位置信息</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>(</span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>使用网络进行定位</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>)</span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>、访问确切位置信息</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>(</span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>使用</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>GPS</span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>和网络进行定位</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>)</span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>、获取任务信息、读取手机状态和身份、修改或删除存储卡中的内容、更改</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>WLAN</span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>状态</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>处理方式</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>去标识化、加密传输的安全处理方式</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>隐私政策</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  https://wiki.connect.qq.com/qq%E4%BA%92%E8%81%94sdk%E9%9A%90%E7%A7%81%E4%BF%9D%E6%8A%A4%E5%A3%B0%E6%98%8E  </span>
          </p>

          <p class=MsoNormal><span lang=EN-US style='font-size:10.0pt;font-family:FangSong'>&nbsp;</span></p>

          <p class="MsoNormal sdk-title"><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>SDK</span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>名称</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>   </span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>：</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'> </span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>穿山甲</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>SDK</span></b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'> </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>所属机构及官网</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>北京巨量引擎网络技术有限公司</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    https://www.csjplatform.com/</span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>使用目的及场景</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>广告投放、反作弊</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>信息种类</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>设备标识、存储、地理位置信息</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>处理方式</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>去标识化、加密传输的安全处理方式</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>隐私政策</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  https://www.csjplatform.com/privacy    </span>
          </p>

          <p class=MsoNormal><span lang=EN-US style='font-size:10.0pt;font-family:FangSong'>&nbsp;</span></p>

          <p class="MsoNormal sdk-title"><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>SDK</span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>名称</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>   </span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>：</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'> </span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>快手</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>SDK</span></b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>所属机构及官网</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>北京快手科技有限公司</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'> https://www.kuaishou.com/</span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>使用目的及场景</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>推送消息、投放广告</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>信息种类</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>设备标识信息、文件读取权限</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>处理方式</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>去标识化、加密传输的安全处理方式</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>隐私政策</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  https://www.kuaishou.com/about/policy?tab=privacy    </span>
          </p>

          <p class=MsoNormal><span lang=EN-US style='font-size:10.0pt;font-family:FangSong'>&nbsp;</span></p>

          <p class="MsoNormal sdk-title"><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>SDK</span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>名称</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>   </span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>：</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'> </span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>应用宝</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>SDK </span></b></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>所属机构及官网</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>腾讯公司</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   https://wiki.open.qq.com/wiki/%E5%BA%94%E7%94%A8%E5%AE%9D%E5%B9%BF%E5%91%8ASDK</span>
          </p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>使用目的及场景</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>推送消息、投放广告</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>信息种类</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>设备标识信息、存储、地理位置</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>处理方式</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>去标识化、加密传输的安全处理方式</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>隐私政策</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  https://privacy.qq.com/  </span></p>

          <p class=MsoNormal><span lang=EN-US style='font-size:10.0pt;font-family:FangSong'>&nbsp;</span></p>

          <p class="MsoNormal sdk-title"><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>SDK</span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>名称</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>   </span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>：</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'> UC SDK</span></b></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>所属机构及官网</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>广州市动景计算机科技有限公司</span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>使用目的及场景</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>广告投放，保障网络及运营安全、了解产品适配性、识别账号异常状态、报送错误。</span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>信息种类</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>设备标识信息、设备信息（如设备型号、操作系统版本、设备设置、必要的移动应用列表信息、网络设备信息、设备环境信息）、设备位置信息、日志信息。</span>
          </p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>处理方式</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>去标识化、加密传输的安全处理方式</span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>隐私政策</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US
              style='font-size:10.0pt;font-family:FangSong'>  https://e.uc.cn/sso/static/pages/hcsso.html</span></p>

          <p class=MsoNormal><span lang=EN-US style='font-size:10.0pt;font-family:FangSong'>&nbsp;</span></p>

          <p class="MsoNormal sdk-title"><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>SDK</span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>名称</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>   </span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>：</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'> SigmobAd SDK  </span></b></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>所属机构及官网</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>北京创智汇聚科技有限公司</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'> https://m.sigmob.com/</span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>使用目的及场景</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>投放广告</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>信息种类</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>设备标识信息、文件读取权限、存储</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>处理方式</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>去标识化、加密传输的安全处理方式</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>隐私政策</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  https://www.sigmob.com/policy.html </span></p>

          <p class=MsoNormal><span lang=EN-US style='font-size:10.0pt;font-family:FangSong'>&nbsp;</span></p>

          <p class="MsoNormal sdk-title"><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>SDK</span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>名称</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>   </span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>：</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'> </span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>友盟</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>SDK</span></b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>       </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>所属机构及官网</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>友盟同欣（北京）科技有限公司</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>北京锐讯灵通科技有限公司</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'> https://www.umeng.com/</span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>使用目的及场景</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>统计分析</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>      </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>信息种类</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>设备标识信息、文件读取权限、存储</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>       </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>处理方式</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>去标识化、加密传输的安全处理方式</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>       </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>隐私政策</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  https://www.umeng.com/page/policy      </span>
          </p>

          <p class=MsoNormal><span lang=EN-US style='font-size:10.0pt;font-family:FangSong'>&nbsp;</span></p>

          <p class="MsoNormal sdk-title"><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>SDK</span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>名称</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>   </span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>：</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'> </span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>数据漫游者</span></b><b><span lang=EN-US style='font-size:10.0pt;
font-family:FangSong'> SDK</span></b><span lang=EN-US style='font-size:10.0pt;
font-family:FangSong'>    </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>所属机构及官网</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>北京涨点姿势科技有限公司</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'> https://datarangers.com.cn/help/doc?lid=2230&amp;did=25685</span>
          </p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>使用目的及场景</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>推送消息、投放广告</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>信息种类</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>设备标识信息、文件读取权限</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>处理方式</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>去标识化、加密传输的安全处理方式</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>隐私政策</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  https://datarangers.com.cn/help/doc?lid=1584&amp;did=10959</span>
          </p>

          <p class=MsoNormal><span lang=EN-US style='font-size:10.0pt;font-family:FangSong'>&nbsp;</span></p>

          <p class="MsoNormal sdk-title"><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>SDK</span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>名称</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>   </span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>：</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'> </span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>中国移动</span></b><b><span lang=EN-US style='font-size:10.0pt;
font-family:FangSong'>  </span></b></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>所属机构及官网</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  http://dev.10086.cn/docInside?contentId=10000009833270  http://dev.10086.cn/docInside?contentId=10000009826661</span>
          </p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>使用目的及场景</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>登录</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>信息种类</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>读取手机状态和身份、修改系统设置</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>处理方式</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>去标识化、加密传输的安全处理方式</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>隐私政策</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  https://wap.cmpassport.com/resources/html/contract.html</span>
          </p>

          <p class=MsoNormal><span lang=EN-US style='font-size:10.0pt;font-family:FangSong'>&nbsp;</span></p>

          <p class="MsoNormal sdk-title"><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>SDK</span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>名称</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>   </span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>：</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'> </span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>微信支付</span></b><b><span lang=EN-US style='font-size:10.0pt;
font-family:FangSong'>SDK  </span></b></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>所属机构及官网</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>腾讯公司</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   https://pay.weixin.qq.com/wiki/doc/api/app/app.php?chapter=11_1</span>
          </p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>使用目的及场景</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>支付</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>信息种类</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>网络状态、</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>Wifi</span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>状态、手机状态、读写存储空间</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>处理方式</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>去标识化、加密传输的安全处理方式</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>隐私政策</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&amp;t=weixin_agreement&amp;s=privacy  </span>
          </p>

          <p class=MsoNormal><span lang=EN-US style='font-size:10.0pt;font-family:FangSong'>&nbsp;</span></p>

          <p class="MsoNormal sdk-title"><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>SDK</span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>名称</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>   </span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>：</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'> </span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>支付宝</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>SDK </span></b></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>所属机构及官网</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>支付宝（中国）网络技术有限公司</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  https://docs.open.alipay.com/54/104509</span>
          </p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>使用目的及场景</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>支付</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>信息种类</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>网络状态、</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>Wifi</span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>状态、手机状态、读写存储空间</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>处理方式</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>去标识化、加密传输的安全处理方式</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>隐私政策</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  https://render.alipay.com/p/c/k2cx0tg8 </span>
          </p>

          <p class=MsoNormal><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>&nbsp;</span></b></p>

          <p class="MsoNormal sdk-title"><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>SDK</span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>名称</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>   </span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>：</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'> New-C2DX  </span></b></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>所属机构及官网</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  MobClub    https://github.com/MobClub/New-C2DX-For-ShareSDK</span>
          </p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>使用目的及场景</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>    </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>分享</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>信息种类</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>修改或删除存储卡中的内容</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'> </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>处理方式</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>去标识化、加密传输的安全处理方式</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>隐私政策</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>   </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>  https://docs.github.com/en/free-pro-team@latest/github/site-policy/github-privacy-statement    </span>
          </p>

          <p class=MsoNormal><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>&nbsp;</span></b></p>
          <p class="MsoNormal sdk-title"><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'>SDK</span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>名称</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'> </span></b><b><span lang=ZH-CN style='font-size:10.0pt;font-family:
FangSong'>：</span></b><b><span lang=EN-US style='font-size:10.0pt;font-family:
FangSong'> 233广告SDK  </span></b></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>SDK提供方名称</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'> </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'> 北京龙威互动科技有限公司 </span>
          </p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>SDK使用目的</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'> </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'> </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>提供及加载第三方广告 https://www.233leyuan.com/dsfsdk.html </span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'> </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>SDK收集的信息</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'> </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'> </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>可能会收集包含IMEI、IMSI、android ID、OAID、设备标识、设备MAC地址、设备序列号，以及手机型号、手机系统版本号、系统编号、系统ID号、屏幕分辨率、上网类型等信息。</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'> </span></p>

          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>处理方式</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'> </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'> </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>去标识化、加密传输的安全处理方式</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'> </span></p>
          <p class=MsoNormal><span lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>隐私政策</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'> </span><span
              lang=ZH-CN style='font-size:10.0pt;font-family:FangSong'>：</span><span
              lang=EN-US style='font-size:10.0pt;font-family:FangSong'>https://www.233leyuan.com/policy.html</span>
          </p>
        </div>
      </div>
    </div>
    <!--<yw-footer></yw-footer>-->
  </div>
</template>

<script>

export default {
  name: "cp_info_gzxb",
  mounted() {
    // 切换页面时滚动条自动滚动到顶部
    window.scrollTo(0,0);
  },
  created() {

  }
}
</script>

<style scoped>
body {
  padding: 0.15rem 0.1rem;
}

h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
  margin: 0;
  text-align: start;
}

h2 {
  font-size: 0.2rem;
}

p {
  font-size: 0.15rem;
  text-align: start;
}

.sdk-title {
  margin-top: 5px;
}

.sdk-title:before {
  content: "●";
  font-size: 5pt;
  text-align: center;
  display: inline-block;
  -webkit-transform: translateY(-20%);
  -moz-transform: translateY(-20%);
  -ms-transform: translateY(-20%);
  transform: translateY(-20%);
  height: 10pt;
  width: 10pt;
}
</style>



// WEBPACK FOOTER //
// src/components/cp_info.vue